import { VideoPlaybackProvider } from '@app/core/playback/video/VideoPlaybackProvider';
import { PlaybackVideoJsPlayer } from '@app/modules/fragments/screens/view/components/video/media-player/PlaybackVideoJsPlayer';
import { Box } from '@mui/material';
import React from 'react';
import { FrameSetControls } from './FrameSetControls';

/**
 * Video frame selector.
 * Allows selecting a specific moment from the video to use as thumbnail.
 */
export function FrameSelector({
  time,
  onSelect,
  unit,
  children,
  src,
}: {
  time: number | null;
  onSelect: (time: number | null) => void;
  unit?: 'seconds' | 'ms';
  children?: React.ReactNode;
  src: string;
}) {
  return (
    <Box>
      <VideoPlaybackProvider src={src}>
        <PlaybackVideoJsPlayer
          options={{
            bigPlayButton: false,
            controlBar: {
              pictureInPictureToggle: false,
              fullscreenToggle: false,
              currentTimeDisplay: true,
              remainingTimeDisplay: false,
            },
          }}
        />
        <FrameSetControls time={time} onSelect={onSelect} unit={unit} />
        {children}
      </VideoPlaybackProvider>
    </Box>
  );
}
